import { CSSProperties } from "react";

interface ToDoTagProps {
	title: string;
	className?: string;
	style?: CSSProperties;
	icon?: React.ReactNode;
}

export default function ToDoTag({ title, className, style, icon }: ToDoTagProps) {
	return (
		<span
			className={`bg-accent-tint py-1 px-2 max-w-[60%] text-ellipsis text-nowrap overflow-hidden rounded-md text-[14px] text-primary-blue font-medium ${className}`}
			style={style}
		>
			{icon}
			{title?.split("/")?.[0]}
		</span>
	);
}
